// StatusGlyph kinds and their shape colours, kept out of the component module (react-refresh/only-export-components).
// The text colour for each kind lives in src/styles/showcase-bridge.css under `[data-glyph-text="…"]`.
export type GlyphKind = 'empty' | 'half' | 'full' | 'done' | 'clock' | 'alert' | 'up' | 'down';

/** The colour each glyph's SHAPE is drawn in. The schedule progression reads as progress, never grey:
 *  Confirmed hollow (meta outline) → Checked in HALF-filled blue → In room full blue → Done green check
 *  (shape green/500, the word in good-text). */
export const GLYPH_SHAPE: Record<GlyphKind, string> = {
  empty: 'var(--ink-meta)',
  half: 'var(--accent-primary)',
  full: 'var(--accent-primary)',
  done: 'var(--status-good)',
  clock: 'var(--status-attention)',
  alert: 'var(--status-bad)',
  up: 'var(--status-attention)',
  down: 'var(--status-attention)',
};

/** A DS StatusChip semantic as a glyph: status is a shape plus coloured words, never a tinted chip.
 *  Needs attention (warning) is the amber triangle, never red; only an error is the red alert. */
export const SEMANTIC_GLYPH: Record<'success' | 'warning' | 'error' | 'info' | 'neutral', GlyphKind> = {
  success: 'done',
  warning: 'up',
  error: 'alert',
  info: 'half',
  neutral: 'empty',
};
